import { render, staticRenderFns } from "./SuspendConnectionModal.vue?vue&type=template&id=1bbcb798"
import script from "./SuspendConnectionModal.vue?vue&type=script&lang=js"
export * from "./SuspendConnectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports